import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import BrandLogoIcon from '../../../components/Images/BrandLogoIcon'
import { handleEventLog, handlePageLoadEventLog } from '../../../lib/utils'
import WriterBenefitBannerSVG from '../../../components/Images/WriterBenefitBannerSVG'
import ChevronRight from '../../../components/Images/ChevronRight'
import ChevronDown from '../../../components/Images/ChevronDown'
import PlayOutlineIcon from "../../../components/Images/PlayOutlineIcon"
import PocketFMIcon from '../../../components/Images/PocketFMIcon'
import ImportantNoteIcon from '../../../components/Images/ImportantNoteIcon'
import { get, set, unset } from '../../../lib/storage'
import { daysDifference } from '../../Home/contests'
import {
  Accordion,
  AccordionBtn,
  AccordionContainer,
  AccordionText,
  Banner,
  BannerCreateNovelBtn,
  BannerHeading,
  BannerSubHeading,
  BannerSVGContainer,
  BannerTextContainer,
  CardChevronBtn,
  Container,
  FrequentlyAskedQuestions,
  FrequentlyAskedQuestionsHeading,
  HowItWorks,
  HowItWorksBtn,
  HowItWorksBtnContainer,
  HowItWorksCard,
  HowItWorksCardHeading,
  HowItWorksCardIconContainer,
  HowItWorksCardsContainer,
  HowItWorksCardText,
  HowItWorksCreateNovelBtn,
  HowItWorksHeading,
  HowItWorksMobileCard,
  InfoContainer,
  Notification,
  NotificationText,
  NovelDetails,
  NovelName,
  PopularWriters,
  PopularWritersCards,
  PopularWritersCardsContainer,
  PopularWritersHeading,
  ProgramDeadline,
  ProgramDeadlineCreateNewNovelBtn,
  ProgramDeadlineSubHeading,
  ProgramDeadlineHeading,
  ProgramDeadlineText,
  RewardsAndBenefits,
  RewardsAndBenefitsCards,
  RewardsAndBenefitsCardsContainer,
  RewardsAndBenefitsCardsHeading,
  RewardsAndBenefitsCardsSubHeading,
  RewardsAndBenefitsCreateNovelBtn,
  RewardsAndBenefitsHeading,
  RewardsAndBenefitsNote,
  RewardsAndBenefitsNoteList,
  RewardsAndBenefitsNoteText,
  RewardsAndBenefitsSubHeading,
  RewardsAndBenefitsTable,
  WriteAtCreateNovelBtn,
  WriteAtHome,
  WriteAtHomeHeading,
  WriteAtHomeText,
  WriteAtHomeTextContainer,
  WriteAtSVGContainer,
  WriterImg,
  WriterImgContainer,
  WriterName,
  WritersBenefitHeader,
  WritersBenefitHeaderLink,
  WritersBenefitHeaderLinks,
  WritersBenefitProgramNotification,
  WriteAtHomeNote,
  ProgramDeadlineSub,
  RewardsAndBenefitsCardsWrapper,
  RewardsAndBenefitsData,
  RewardsAndBenefitsImage,
  ModalIframe,
  PocketInTheNewsHeading,
  PocketInTheNews,
  PocketInTheNewsCard,
  PocketInTheNewsImage,
  PocketInTheNewsContent,
  PocketInTheNewsDate,
  PocketInTheNewsTitle,
  PocketInTheNewsBrief,
  PocketInTheNewsCardsContainer,
  PocketInNewsMobileCard,
  PocketInTheNewsBtnContainer,
  PocketInTheNewsBtn,
} from './styles'

import { languageTranslationObject } from "../../../languages";
import { Popup } from '../../../components/Popup'
import { Box } from '../../../designSystem'
import CrossIcon from '../../../components/Images/CrossIcon'
import Loader from '../../../components/Loader'
const mobileBreakPoint = 600 //600px viewport width breakpoint

const WritersBenefitUI = ({ history,location, language, isUserFromUS = null, disabled=false, disabledMessage}) => {
  const translation  = {...languageTranslationObject[language]};
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < mobileBreakPoint ? true : false)
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState({url:"", heading:""});
  const [modalContentLoading, setModalContentLoading] = useState(true);
  const [step, setStep] = useState(0)  
  const [pocketInTheNewsStep, setPocketInTheNewsStep] = useState(0);
  const [ytIframeVideoCode, setYtIframeVideoCode] = useState('');
  const isAuthorWelfarePath = location.pathname.includes("author-welfare")
  const resizeWindowHandler = () => setIsMobileView(window.innerWidth < mobileBreakPoint ? true : false)
  const createNewNovelHandler = (buttonName) => {
    handleEventLog('writer_benefit','button_click',{route : window.location.pathname + window.location.search,button:buttonName})
    history.push('/shows/novels?open-new=1')
  }
  const toggleExtraInfoHandler = (e) => {
    const extraInfoElement = e.currentTarget.previousElementSibling
    if(extraInfoElement.tagName === "OL"){
      e.currentTarget.classList.toggle("open")
      extraInfoElement.style.maxHeight ? extraInfoElement.style.maxHeight = null : extraInfoElement.style.maxHeight =  extraInfoElement.scrollHeight + 'px'
    }
  }
  const toggleAccordionTextHandler = (e) => {
    const accordionTextElement = e.currentTarget.nextElementSibling
    if(accordionTextElement.tagName === "DIV"){
      e.currentTarget.classList.toggle("open")
      accordionTextElement.style.maxHeight ? accordionTextElement.style.maxHeight = null : accordionTextElement.style.maxHeight =  accordionTextElement.scrollHeight + 'px'
    }
  }
  const changeStepHandler = value => setStep(value - 1)

  // Writer Benefit Video Notification will deploy in next release
  const showWritersBenefitProgramNotificationHandler = () => {
    // show video player
  }

  const youTubeLinkHandler = (videoCode) => {
    setYtIframeVideoCode(videoCode)
 }

  useEffect(() => {
    window.addEventListener('resize', resizeWindowHandler)
    set('writers_benefit_start_time', Date.now())
    handlePageLoadEventLog('writer_benefit')

    return () => {
      window.removeEventListener('resize', resizeWindowHandler) 
      const endTime = Date.now()
      const startTime = +get('writers_benefit_start_time')
      const timeDiff = (endTime - startTime) / 1000
      handleEventLog('writer_benefit', 'time_spent_on_page', { time: timeDiff, route: window.location.pathname + window.location.search })
      unset('writers_benefit_start_time')
    }
  }, [])


  if(language === undefined) return <h3>Loading /..</h3>
  const StepSVG = translation?.howItWorksArray[step]?.stepSVG

  let showPopUpMessage = "";
  if(language=="bengali" || language=="marathi"){
    showPopUpMessage = "Currently, we are only open for Hindi,Tamil,English Authors"
  }
  if(disabled){
    showPopUpMessage = disabledMessage ?? <>Program is temporarily on hold in your country<br/><small><Link to="/login" style={{'color':'#068ae2'}}>Signup here</Link> to receive any update</small></>
  }
  return (
  
    <Container>
      {ytIframeVideoCode && <Popup show close={()=> setYtIframeVideoCode('')} className={'YouTube_Iframe'} closeMarksStyles={{top: '20%'}}>
              <div style={{position:'relative', paddingBottom: '56.25%'}}>
                <iframe style={{position:'absolute', top: '0', left: '0', height: '100%', width: '100%'}} src={`https://www.youtube.com/embed/${ytIframeVideoCode}?autoplay=1`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </Popup>}
      {showPopUpMessage && <Popup
            show
        >
            <Box style={{height: disabledMessage ? '90vh' : 'auto', fontSize:'24px', textAlign: 'center',overflow:'scroll'}} >
              {showPopUpMessage}
            </Box>
        </Popup>}
      {isAuthorWelfarePath && !isUserFromUS && <WritersBenefitHeader>
        <PocketFMIcon width={isMobileView ? "100" : "132"} height={isMobileView ? "22" : "30"}/>
        <WritersBenefitHeaderLinks>
          <WritersBenefitHeaderLink target="_blank" href="mailto:writers@pocketfm.in">Contact Us</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink href="#faq">FAQ's</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink onClick={() => createNewNovelHandler('get_started')}>{isMobileView ? "Get Started" : "Get your journey started"}</WritersBenefitHeaderLink>
        </WritersBenefitHeaderLinks>
      </WritersBenefitHeader>}
      {/* <WritersBenefitProgramNotification >
        <Notification onClick={showWritersBenefitProgramNotificationHandler}>
          <PlayOutlineIcon width="24" height="24" />
          <NotificationText>Click here to know more about <strong>Writers Benefit Program</strong></NotificationText>
        </Notification>
      </WritersBenefitProgramNotification> */}
      <Banner>
        <BannerTextContainer>
          <BrandLogoIcon
            width={isMobileView ? '95' : '162'}
            height={isMobileView ? '23' : '50'}
          />
          <BannerHeading>
            {isMobileView ? (isUserFromUS ? 'Writers Benefit' : translation.introduction_heading) : 'Writers Benefit'}
          </BannerHeading>
          {(!isMobileView || isUserFromUS)&& <BannerSubHeading>Program</BannerSubHeading>}
          <BannerCreateNovelBtn onClick={() => createNewNovelHandler('create_new_novel')}>
            <span> {translation.create_novel_button_text} </span>
            <ChevronRight fillOpacity="1" />
          </BannerCreateNovelBtn>
        </BannerTextContainer>
        <BannerSVGContainer>
          <WriterBenefitBannerSVG />
        </BannerSVGContainer>
      </Banner>
      <RewardsAndBenefits isUserFromUS={isUserFromUS}>
        <RewardsAndBenefitsHeading isUserFromUS={isUserFromUS}>
          {translation.rewards_title}
        </RewardsAndBenefitsHeading>
        <RewardsAndBenefitsSubHeading isUserFromUS={isUserFromUS}>{translation.rewards_para_text}</RewardsAndBenefitsSubHeading>

        <RewardsAndBenefitsCardsContainer isUserFromUS={isUserFromUS}>
        {translation.rewardsAndBenefitsArray.map((data, index) => (
          <RewardsAndBenefitsCardsWrapper key={index} isUserFromUS={isUserFromUS}>
            <RewardsAndBenefitsCards isUserFromUS={isUserFromUS}>
              <RewardsAndBenefitsCardsHeading isUserFromUS={isUserFromUS}>{data.heading}</RewardsAndBenefitsCardsHeading>
              {!isMobileView && data?.subHeading && <RewardsAndBenefitsCardsSubHeading>{data.subHeading}</RewardsAndBenefitsCardsSubHeading>}
              {isMobileView && isUserFromUS && data?.mobileSubHeading && <RewardsAndBenefitsCardsSubHeading>{data.mobileSubHeading}</RewardsAndBenefitsCardsSubHeading>}
              {(!isUserFromUS || isMobileView) && <RewardsAndBenefitsTable>
                <thead>
                  <tr>
                    {data.tableHeadings.map((tableheading, index) => (
                      <th key={index}>{tableheading}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.table.map((tableRow, index) => (
                    <tr key={index}>
                      <td>{tableRow.wordCount}</td>
                      <td>{tableRow.reward}</td>
                      {tableRow?.bonus && <td>{tableRow.bonus}</td>}
                    </tr>
                  ))}
                </tbody>
              </RewardsAndBenefitsTable>}
              <RewardsAndBenefitsNote>
                <ImportantNoteIcon
                width={isMobileView ? '24' : '34'}
                height={isMobileView ? '24' : '34'}
                />
                <RewardsAndBenefitsNoteText isUserFromUS={isUserFromUS}>{data.note}</RewardsAndBenefitsNoteText>
              </RewardsAndBenefitsNote>
              {data.extraNotes.length > 0 && 
              <>
                <RewardsAndBenefitsNoteList>
                  {data.extraNotes.map((note) => (
                    <li key={note.no}>{note.text}</li>
                  ))}
                </RewardsAndBenefitsNoteList>
                <CardChevronBtn onClick={toggleExtraInfoHandler}>
                  <ChevronDown width="24" height="24" fillOpacity="1" />
                </CardChevronBtn>
              </>
              }
            </RewardsAndBenefitsCards>
            {isUserFromUS && <RewardsAndBenefitsData>
              {index === 0 ? <RewardsAndBenefitsImage alt="coins bag" src={data?.coinsBagImageSrc} />: (<RewardsAndBenefitsTable isUserFromUS={isUserFromUS}>
                <thead>
                  <tr>
                    {data.tableHeadings.map((tableheading, index) => (
                      <th key={index}>{tableheading}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.table.map((tableRow, index) => (
                    <tr key={index}>
                      <td>{tableRow.wordCount}</td>
                      <td>{tableRow.reward}</td>
                      {tableRow?.bonus && <td>{tableRow.bonus}</td>}
                    </tr>
                  ))}
                </tbody>
              </RewardsAndBenefitsTable>)}
            </RewardsAndBenefitsData>}
          </RewardsAndBenefitsCardsWrapper>
        ))}
        </RewardsAndBenefitsCardsContainer>     
        {!isMobileView && !isUserFromUS && <RewardsAndBenefitsCreateNovelBtn onClick={() => createNewNovelHandler('start_writing')}>
          <span>Start writing your novel</span>
          <ChevronRight fillOpacity="1" />
        </RewardsAndBenefitsCreateNovelBtn>}
      </RewardsAndBenefits>
      {(isMobileView || isUserFromUS) && <ProgramDeadline>
          <ProgramDeadlineHeading>
          {translation.deadline_content}
            {/* <span>Deadline to Enter Program</span><span role="img" aria-label="finish flag">🏁</span> */}
          </ProgramDeadlineHeading>
          {isUserFromUS && <ProgramDeadlineSub>{translation.deadline_subheading}</ProgramDeadlineSub>}
          {!isUserFromUS && <ProgramDeadlineText>{translation.date}<sup>{translation.dateSuffix}</sup> {translation.monthInWords} : {daysDifference(new Date(translation.year,translation.month,translation.deadline_date) - new Date()) } {translation.days_or} {Math.floor(daysDifference(new Date(translation.year,translation.month,translation.deadline_date) - new Date()) / 31)} {translation.months_to_go}</ProgramDeadlineText>}
          {isUserFromUS && <ProgramDeadlineText isUserFromUS={isUserFromUS}>{translation.deadline_date}</ProgramDeadlineText>}
          <ProgramDeadlineCreateNewNovelBtn onClick={() => createNewNovelHandler('deadline_pocket_novel')}>
            <span>{translation.deadline_to_enter_button}</span>
            <ChevronRight fillOpacity="1" />
          </ProgramDeadlineCreateNewNovelBtn>
          <ProgramDeadlineSubHeading>{isUserFromUS ? translation.deadline_note : translation.deadline_subheading}</ProgramDeadlineSubHeading>

      </ProgramDeadline>}
      <HowItWorks isUserFromUS={isUserFromUS}>
        <HowItWorksHeading>
          <span>How it Works?</span>
          <span role="img" aria-label="writer-pen">✍️</span>
        </HowItWorksHeading>
        {isMobileView && <HowItWorksMobileCard>
          <HowItWorksCardIconContainer><StepSVG /></HowItWorksCardIconContainer>
          <HowItWorksCardHeading>STEP {translation.howItWorksArray[step].step}</HowItWorksCardHeading>
          <HowItWorksCardText>{translation.howItWorksArray[step].instruction}</HowItWorksCardText>
          <HowItWorksBtnContainer>
            <HowItWorksBtn onClick={() => changeStepHandler(1)} isActive={step+1 === 1} >1</HowItWorksBtn>
            <HowItWorksBtn onClick={() => changeStepHandler(2)} isActive={step+1 === 2}>2</HowItWorksBtn>
            <HowItWorksBtn onClick={() => changeStepHandler(3)} isActive={step+1 === 3}>3</HowItWorksBtn>
            <HowItWorksBtn onClick={() => changeStepHandler(4)} isActive={step+1 === 4}>4</HowItWorksBtn>
          </HowItWorksBtnContainer>
        </HowItWorksMobileCard>}
        {!isMobileView && translation?.howItWorksArray.length > 0 && <HowItWorksCardsContainer>
            {translation?.howItWorksArray.map((data,index) => {
            const StepSVG = data.stepSVG
            return(
            <HowItWorksCard key={index}>
              <HowItWorksCardIconContainer><StepSVG /></HowItWorksCardIconContainer>
              <HowItWorksCardHeading>{translation.step} {data.step}</HowItWorksCardHeading>
              <HowItWorksCardText>{data.instruction}</HowItWorksCardText>
            </HowItWorksCard>
            )}
            )}
        </HowItWorksCardsContainer>}
        {!isMobileView && !isUserFromUS  && <HowItWorksCreateNovelBtn onClick={() => createNewNovelHandler('start_writing')}>
           <span>Start writing your novel</span>
            <ChevronRight fillOpacity="1" />
        </HowItWorksCreateNovelBtn>}
      </HowItWorks>
      {(!isMobileView && !isUserFromUS) && <ProgramDeadline>
          <ProgramDeadlineHeading>
          {translation.deadline_content}
            {/* <span>Deadline to Enter Program</span><span role="img" aria-label="finish flag">🏁</span> */}
          </ProgramDeadlineHeading>
          <ProgramDeadlineText>{translation.date}<sup>{translation.dateSuffix}</sup> {translation.monthInWords} : {daysDifference(new Date(translation.year,translation.month,translation.deadline_date) - new Date()) } {translation.days_or} {Math.floor(daysDifference(new Date(translation.year,translation.month,translation.deadline_date) - new Date()) / 31)} {translation.months_to_go}</ProgramDeadlineText>
          <ProgramDeadlineCreateNewNovelBtn onClick={() => createNewNovelHandler('deadline_pocket_novel')}>
            <span>{translation.deadline_to_enter_button}</span>
            <ChevronRight fillOpacity="1" />
          </ProgramDeadlineCreateNewNovelBtn>
               <ProgramDeadlineSubHeading>{translation.deadline_subheading}</ProgramDeadlineSubHeading>

      </ProgramDeadline>}
      {!isUserFromUS && <PopularWriters>
        <PopularWritersHeading>
          <span>{translation.popular_writter}</span>
          <span role="img" aria-label="pink-heart">💖</span>
        </PopularWritersHeading>
        <PopularWritersCardsContainer>
          {translation.popularWritersArray.map((data, index) => (
            <PopularWritersCards key={index}>
              <WriterImgContainer>
                <WriterImg src={data.writerImgSrc} alt="writer"/>
              </WriterImgContainer>
              <InfoContainer>
                <WriterName>{data.writerName}</WriterName>
                <NovelName><span>{data.novelName}</span></NovelName>
                <NovelDetails>{data.plays} Plays • {data.words} Words</NovelDetails>
              </InfoContainer>
            </PopularWritersCards>
            ))}
        </PopularWritersCardsContainer>
      </PopularWriters>}
      {isAuthorWelfarePath && isUserFromUS && <PocketInTheNews id="pocketInTheNews">
        <PocketInTheNewsHeading>
          <span>Pocket in the News</span>
          <span role="img" aria-label="tada">🎉</span>
        </PocketInTheNewsHeading>
        {!isMobileView && translation?.pocketInTheNewsArray.length > 0 && <PocketInTheNewsCardsContainer>
            {translation?.pocketInTheNewsArray.map(data => 
            (<PocketInTheNewsCard key={data?.id} href={data?.link} target="_blank">
              <PocketInTheNewsImage src={data?.imageSrc} loading="lazy" />
              <PocketInTheNewsContent>
                <PocketInTheNewsDate>{data?.date} | {data?.by}</PocketInTheNewsDate>
                <PocketInTheNewsTitle>{data?.title}</PocketInTheNewsTitle>
                <PocketInTheNewsBrief>{data?.brief}</PocketInTheNewsBrief>
              </PocketInTheNewsContent>
            </PocketInTheNewsCard>
            ))}
        </PocketInTheNewsCardsContainer>}
        {isMobileView && <PocketInNewsMobileCard>
          <PocketInTheNewsImage src={translation.pocketInTheNewsArray[pocketInTheNewsStep]?.imageSrc} />
          <PocketInTheNewsDate>{translation.pocketInTheNewsArray[pocketInTheNewsStep]?.date} | {translation.pocketInTheNewsArray[pocketInTheNewsStep]?.by}</PocketInTheNewsDate>
          <PocketInTheNewsTitle>{translation.pocketInTheNewsArray[pocketInTheNewsStep]?.title}</PocketInTheNewsTitle>
          <PocketInTheNewsBrief><a href={translation.pocketInTheNewsArray[pocketInTheNewsStep]?.link} target="_blank">{translation.pocketInTheNewsArray[pocketInTheNewsStep]?.brief}</a></PocketInTheNewsBrief>
          <PocketInTheNewsBtnContainer>
            <PocketInTheNewsBtn onClick={() => setPocketInTheNewsStep(0)} isActive={pocketInTheNewsStep+1 === 1} ></PocketInTheNewsBtn>
            <PocketInTheNewsBtn onClick={() => setPocketInTheNewsStep(1)} isActive={pocketInTheNewsStep+1 === 2}></PocketInTheNewsBtn>
            <PocketInTheNewsBtn onClick={() => setPocketInTheNewsStep(2)} isActive={pocketInTheNewsStep+1 === 3}></PocketInTheNewsBtn>
            <PocketInTheNewsBtn onClick={() => setPocketInTheNewsStep(3)} isActive={pocketInTheNewsStep+1 === 4}></PocketInTheNewsBtn>
          </PocketInTheNewsBtnContainer>
        </PocketInNewsMobileCard>}
        </PocketInTheNews>}
      <FrequentlyAskedQuestions id="faq">
        <FrequentlyAskedQuestionsHeading>
          <span>{translation.faq}</span>
          <span role="img" aria-label="question">❓</span>
        </FrequentlyAskedQuestionsHeading>
        <AccordionContainer>
          {translation.frequentlyAskedQuestionsArray.map((data,index)=> 
          <Accordion key={index}>
            <AccordionBtn onClick={toggleAccordionTextHandler}>{data.question}</AccordionBtn>
            <AccordionText>
              <span dangerouslySetInnerHTML={{ __html: data.answer }}></span>
              {data.youtubeLink && <span style={{ color : 'blue',cursor: 'pointer'}} onClick={()=> youTubeLinkHandler(data.youtubeLink)}>here</span>}
            </AccordionText>
          </Accordion>
          )} 
        </AccordionContainer>
      </FrequentlyAskedQuestions>
      <WriteAtHome>
        <WriteAtHomeTextContainer>
          <WriteAtHomeHeading>{translation.write_home_earn_stable_income_text}</WriteAtHomeHeading>
          <WriteAtHomeText> {translation.write_home_earn_stable_income_subheading}  </WriteAtHomeText>
          <WriteAtCreateNovelBtn onClick={() => createNewNovelHandler('create_new_novel')}>       
            <span>{translation.create_new_novel}</span>
            <ChevronRight fillOpacity="1" />
          </WriteAtCreateNovelBtn>
          {isUserFromUS && <WriteAtHomeNote>{translation.footer_note}</WriteAtHomeNote>}
        </WriteAtHomeTextContainer>
        <WriteAtSVGContainer>
            <WriterBenefitBannerSVG />
        </WriteAtSVGContainer>
      </WriteAtHome>
      {isAuthorWelfarePath && isUserFromUS && <WritersBenefitHeader isUserFromUS={isUserFromUS}>
        <PocketFMIcon width={isMobileView ? "100" : "132"} height={isMobileView ? "22" : "30"}/>
        <WritersBenefitHeaderLinks isUserFromUS={isUserFromUS}>
          <WritersBenefitHeaderLink isUserFromUS={isUserFromUS} href="#pocketInTheNews">Pocket in the News</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink isUserFromUS={isUserFromUS} onClick={() => {setModalContentLoading(true);setIsModalVisible(true); setModalData({url:"https://www.pocketfm.com/terms-and-conditions",heading:"Terms & Conditions"})}}>Terms &amp; Conditions</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink isUserFromUS={isUserFromUS} onClick={() => {setModalContentLoading(true);setIsModalVisible(true); setModalData({url:"https://www.pocketfm.com/privacy-policy",heading:"Privacy Policy"})}}>Privacy Policy</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink isUserFromUS={isUserFromUS} target="_blank" href="mailto:writers@pocketfm.in">Contact Us</WritersBenefitHeaderLink>
          <WritersBenefitHeaderLink isUserFromUS={isUserFromUS}href="#faq">FAQ's</WritersBenefitHeaderLink>
        </WritersBenefitHeaderLinks>
      </WritersBenefitHeader>}
      {isAuthorWelfarePath && isUserFromUS && isModalVisible && <Popup show={isModalVisible} close={() => {setModalContentLoading(true);setIsModalVisible(false); setModalData({url:"", heading:""})}} className="fullview-modal" >
        <Box variant="flex">
          <Box width={["100%"]} />
          <Box><CrossIcon onClick={() => {setIsModalVisible(false); setModalData({url:"", heading:""})}} /></Box>
        </Box>
        {modalContentLoading && <Loader size="md" />}
        {<ModalIframe title={modalData?.heading} src={modalData?.url} frameBorder="0" onLoad={()=> setModalContentLoading(false)}>
            <p>This browser does not support iframe!</p>
        </ModalIframe>}
    </Popup>}
    </Container>
  )
}
export default WritersBenefitUI
